export const site = {
  siteName: "All Yono Games",
  siteUrl: "https://allyono.online",
  logo: "/images/logo.webp",
  banner: "/images/banner.webp",
  affiliateUrl: "https://go.7who.xyz/click?pid=31314&offer_id=5852",
  copyrightText: "All rights reserved.",
};